import React, {useState} from 'react';
import {Redirect} from 'react-router-dom';

import Input from '../../components/UI/Input/FormInput';
import {Row, Col, Button, Form, FormGroup} from 'reactstrap';
import * as actions from '../../store/actions/index';
import {connect} from 'react-redux';
import {checkValidity} from "../../shared/utility";

const Auth = ({onAuth, loading, isAuthenticated}) => {
    const [controls, setControls] = useState({
        contactEmail: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
                placeholder: 'E-Mail-Adresse',
                label: 'E-Mail-Adresse',
                autoComplete: 'email',
                columns: 12
            },
            value: '',
            validation: {
                required: true,
                isEmail: true
            },
            valid: false,
            errorMessage: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
            touched: false
        },
        contactPassword: {
            elementType: 'input',
            elementConfig: {
                type: 'password',
                placeholder: 'Passwort',
                label: 'Passwort',
                autoComplete: 'current-password',
                columns: 12
            },
            value: '',
            validation: {
                required: true,
            },
            valid: false,
            errorMessage: 'Bitte geben Sie Ihr Passwort ein',
            touched: false
        }
    });

    const onChangedHandler = (event, controlName) => {
        const validity = checkValidity(event.target.value, controls[controlName].validation);

        const updatedControls = {
            ...controls,
            [controlName]: {
                ...controls[controlName],
                value: event.target.value,
                valid: validity.isValid,
                errorMessage: validity.errorMessage ?? '',
                touched: true
            }
        };
        setControls(updatedControls);
    };

    const onSubmitHandler = (event) => {
        event.preventDefault();
        onAuth(controls.contactEmail.value, controls.contactPassword.value);
    };

    const formElementsArray = [];
    for (let key in controls) {
        formElementsArray.push({
            id: key,
            config: controls[key]
        });
    }

    let form = formElementsArray.map(formElement => (
        <Input
            key={formElement.id}
            elementType={formElement.config.elementType}
            elementConfig={formElement.config.elementConfig}
            value={formElement.config.value}
            changed={(event) => onChangedHandler(event, formElement.id)}
            shouldValidate={formElement.config.validation}
            touched={formElement.config.touched}
            errorMessage={formElement.config.errorMessage}
            invalid={!formElement.config.valid}/>
    ));

    if (loading) {
        form = 'loading...';
    }

    let authRedirect = null;
    if (isAuthenticated) {
        authRedirect = <Redirect to="/"/>
    }

    return (
        <Row>
            <Col>
                {authRedirect}
                <Form onSubmit={onSubmitHandler}>
                    {form}
                    <FormGroup row>
                        <Col sm={{size: 12}}>
                            <Button>Anmelden</Button>
                        </Col>
                    </FormGroup>
                </Form>
            </Col>
        </Row>
    );
};

const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthenticated: state.auth.token !== null
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onAuth: (email, password) => dispatch(actions.auth(email, password))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Auth);